import React from 'react';
import * as Styles from './GenericError.styles';
import { Button, IconLoading } from 'gatorcomponents';

const GenericError = ({
  icon, title, buttonLabel, requestTemplates, loading,
}) => (
  <Styles.Wrapper data-testid="generic-error">
    {icon}
    <Styles.Title>{title}</Styles.Title>
    <Styles.WrapperButton>
      <Button
        label={loading ? <IconLoading /> : buttonLabel}
        onClick={() => requestTemplates && requestTemplates()}
        size="large"
        testId="button"
        type="button"
        variant="primary"
        version="v2"
        width="fit-content"
      />
    </Styles.WrapperButton>
  </Styles.Wrapper>
);

export default GenericError;
